import React, { Component } from 'react';
import { ColorPicker, BasePopoverPanel } from 'crazyEditor/components/EditorUI/BaseUI/index';
import _ from 'lodash';
import { connect } from 'react-redux';
import { closeLazyPanel } from 'crazyEditor/redux/modules/panel/panel';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { setElementUpdatePreview, clearElementUpdatePreview, applyElementUpdatePreview } from 'crazyEditor/redux/modules/element/actions/previewElementActions';
import { getElementMethods } from 'crazyEditor/core/elements/utils/elementDefinitionUtils';
import Slider from 'material-ui/Slider';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import { PADDING_PROP_NAMES, BORDER_RADIUS_PROP_NAMES } from 'crazyEditor/core/constants/panelConstants';
import FlipMove from 'react-flip-move';
import InputWrapper from 'crazyEditor/components/EditorUI/BaseUI/InputWrapper/InputWrapper';

@connect(
  false,
  {closeLazyPanel, setElementUpdatePreview, clearElementUpdatePreview, applyElementUpdatePreview}
)
@Radium
export default class BorderRadiusPanel extends Component {
  constructor(props) {
    super();
    this.state = this.getInitialStateFromProps(props);
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.open && nextProps.open) {
      this.setState(this.getInitialStateFromProps(nextProps));
    }
  }

  componentWillUpdate(nextProps, nextState) {
    this.shrinking = !!(this.state.setEachCornerSeparately && !nextState.setEachCornerSeparately);
    this.expanding = !!(!this.state.setEachCornerSeparately && nextState.setEachCornerSeparately);
  }

  onChange = (borderRadius, propName = null) => {
    if (_.isString(borderRadius) && !_.isEmpty(borderRadius) && !/^\d+$/.test(borderRadius)) {
      return;
    }
    const { setElementUpdatePreview } = this.props;
    const element = _.get(this.props, 'panelProps.selectedElements[0]');
    const elementMethods = getElementMethods(element.type);
    const borderRadiusProps = _.pick(this.state, BORDER_RADIUS_PROP_NAMES);
    if (propName) {
      borderRadiusProps[propName] = borderRadius;
    } else {
      _.forEach(BORDER_RADIUS_PROP_NAMES, (propName) => {
        borderRadiusProps[propName] = borderRadius;
      });
    }

    this.setState(borderRadiusProps);
    setElementUpdatePreview(element.id, elementMethods.getBorderRadiusSetter(borderRadiusProps));
  };

  onClose = () => {
    const { closeLazyPanel, panelName, applyElementUpdatePreview} = this.props;

    applyElementUpdatePreview();
    closeLazyPanel(panelName);
  };

  getInitialStateFromProps(props) {
    const element = _.get(props, 'panelProps.selectedElements[0]');
    const initialState = {};
    BORDER_RADIUS_PROP_NAMES.forEach(propName => {
      initialState[propName] = 0;
    });
    _.assign(initialState, _.pick(element.compProps, BORDER_RADIUS_PROP_NAMES));
    initialState.setEachCornerSeparately = _.uniq(_.values(initialState)).length !== 1;
    initialState.maxBorderRadius = Math.min(element.layout.height, element.layout.width) / 2;
    return initialState;
  }

  toggeleSetEachCornerSeparately = () => {
    let { setEachCornerSeparately } = this.state;
    setEachCornerSeparately = !setEachCornerSeparately;
    if (!setEachCornerSeparately) {
      this.onChange(this.state[BORDER_RADIUS_PROP_NAMES[0]]);
    }
    this.setState({setEachCornerSeparately});
  };

  render() {
    const { panelName, anchorEl, open } = this.props;
    const {state, expanding, shrinking} = this;
    const { setEachCornerSeparately, maxBorderRadius } = state;
    let value = this.state[BORDER_RADIUS_PROP_NAMES[0]];
    if (!_.isNil(value)) {
      value = Math.min(parseInt(value, 10), maxBorderRadius);
    }
    return (
      <BasePopoverPanel
        panelName={panelName}
        anchorEl={anchorEl}
        open={open}
        onRequestClose={this.onClose}
        style = {{width: 320, padding: 23, fontSize: 16, height: setEachCornerSeparately ? 330 : 150, transition: 'all 450ms ease-in-out', transitionDelay: shrinking && '200ms'}}
      >
        Corner Radius (px)
        <FlipMove
          style={{width: '100%'}}
          enterAnimation="fade"
          leaveAnimation="fade"
          delay = {expanding ? 200 : 0}
        >
          {
            setEachCornerSeparately
              ?
              BORDER_RADIUS_PROP_NAMES.map(borderPropsName => {
                let value = state[borderPropsName];
                if (!_.isNil(value)) {
                  value = Math.min(parseInt(value, 10), maxBorderRadius);
                }
                return (
                  <div key={borderPropsName} style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <img height={30} width={30} src={require(`./images/${borderPropsName}.svg`)}/>
                    <Slider value={value} min={0} max = {maxBorderRadius} step={1} style={{width: 170, height: 60}} ref="slider" onChange={(event, value) => this.onChange(value, borderPropsName)}/>
                    <InputWrapper type="number" defaultValue={0} value={value} style={{width: 45}} inputStyle={{textAlign: 'center'}} onChange={(event) => this.onChange(event.target.value, borderPropsName)}/>
                  </div>);
              })
              :
              <div key="all" style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                <img height={30} width={30} src={require('./images/all.svg')}/>
                <Slider value={value} min={0} max = {maxBorderRadius} step={1} style={{width: 170, height: 60}} ref="slider" onChange={(event, value) => this.onChange(value)}/>
                <InputWrapper type="number" defaultValue={0} value={value} style={{width: 45}} inputStyle={{textAlign: 'center'}} onChange={(event) => this.onChange(event.target.value, )}/>
              </div>
          }
        <Checkbox key="checkbox" checked={setEachCornerSeparately} onCheck={this.toggeleSetEachCornerSeparately} label="Set each corner separately"/>
        </FlipMove>
      </BasePopoverPanel>
    );
  }
}

BorderRadiusPanel.propTypes = {
  panelName: PropTypes.string.isRequired,
  anchorEl: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  panelProps: PropTypes.object
};